

  import React, {  useRef,  } from 'react';
  import logo from "../../assets/images/log03.png";
  import { useReactToPrint } from 'react-to-print';

  
  const ResultEmptyFileDownload = ({
    students,
    subject,
    classe,
  }) => {

  
    const componentRef = useRef(null);
  
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: 'Order Invoice',
      removeAfterPrint: true,
      pageStyle: `
      @page {
        size: A4;
        margin: 0.5in;
        /* Remove default browser headers and footers */
        @top-left { content: ""; }
        @top-center { content: ""; }
        @top-right { content: ""; }
        @bottom-left { content: ""; }
        @bottom-center { content: ""; }
        @bottom-right { content: ""; }
      }
      
      @media print {
        /* Hide browser default headers/footers */
        @page { 
          margin: 0.5in;
          size: A4;
        }
        
        /* Ensure no browser defaults show */
        html, body {
          -webkit-print-color-adjust: exact;
          color-adjust: exact;
          margin: 0 !important;
          padding: 0 !important;
        }
        
        body {
          font-family: Arial, sans-serif;
        }
        
        /* Hide any unwanted elements during print */
        .no-print {
          display: none !important;
        }
        
        /* Ensure content takes full width */
        .print-content {
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        
        /* Page break controls */
        .page-break {
          page-break-before: always;
        }
        
        .avoid-break {
          page-break-inside: avoid;
        }
      }
    `,
      onAfterPrint: () => console.log('Print completed!'),
      print: async (printIframe) => {
        // Custom print function to ensure proper formatting
        return new Promise((resolve) => {
          const document = printIframe.contentDocument;
          if (document) {
            const window = printIframe.contentWindow;
            if (window) {
              // Add additional styles to remove browser chrome
              const style = document.createElement('style');
              style.textContent = `
              @media print {
                @page {
                  margin: 0.5in;
                  size: A4;
                }
                
                body {
                  margin: 0;
                  padding: 0;
                  -webkit-print-color-adjust: exact;
                  color-adjust: exact;
                }
              }
            `;
              document.head.appendChild(style);
  
              window.focus();
              window.print();
              resolve();
            }
          }
        });
      },
    });
  
    return (
      <div>
        <button className="btn capitalize rounded-3xl py-1 border-[3px] border-purple-500 w-full text-lg font-reem bg-purple-700 text-white" onClick={handlePrint}>Pring {classe} - {subject}  Entry Sheet</button>
        <div className="overflow-hidden w-0 h-0 font-Oswald ">
          <div ref={componentRef} id="pdf-content" className=" bg-white">
              <div
                
                className={`w-[210mm] min-h-[297mm] mx-auto pt-2 p-0 relative z-0`}
                style={{
                  pageBreakAfter: 'auto',
                }}
              >
                <div
                  className="absolute top-0 left-0 w-full h-[267mm]"
                  style={{
                    backgroundImage: `url(${logo})`,
                    backgroundSize: '500px', // Adjust size as per requirement
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.05, // Subtle watermark
                    // zIndex: 1,
                  }}
                ></div>
                {/* Header Section */}
                <div className="text-center mb-6 mt-[-10px]">
                  <h1 className="text-2xl font-bold text-gray-800 mb-1">Nabojagorn Academy</h1>
                  <h2 className="text-md font-semibold text-gray-700 ">Result Entry Sheet - {new Date().getFullYear()}</h2>
                  <p className="text-lg font-bold text-gray-600">Class: {classe} - Subject: {subject}</p>
                </div>

                {/* Table Section */}
                <div className="w-full">
                  <table className="w-full border-collapse border border-gray-400">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border border-gray-400 px-3 py-2 text-left font-semibold text-gray-700 w-[8%]">
                        Roll 
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-left font-semibold text-gray-700 w-[15%]">
                        Student Name
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-center font-semibold text-gray-700 w-1/6">
                        Writing 
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-center font-semibold text-gray-700 w-1/6">
                          MCQ
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-center font-semibold text-gray-700 w-1/6">
                        Practical
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-center font-semibold text-gray-700 w-1/6">
                        ID
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {students?.map((student, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="border border-gray-400 px-2 py-1 max-w-[40px] text-gray-800">
                           <p className='flex items-center gap-x-2'><span className='inline-block'>{student?.roleNo} </span> </p>
                          </td>
                          <td className="border border-gray-400 px-2 py-0.5 font-medium text-lg text-gray-600">
                          <span className='truncate inline-block max-w-[130px] truncate'>{student?.firstName} {student?.lastName}</span>
                          </td>
                          <td className="border border-gray-400 px-2 py-1 text-center">
                            <div className=" w-full  rounded"></div>
                          </td>
                          <td className="border border-gray-400 px-2 py-1 text-center">
                            <div className=" w-full  rounded"></div>
                          </td>
                          <td className="border border-gray-400 px-2 py-1 text-center">
                            <div className=" w-full  rounded"></div>
                          </td>
                          <td className="border border-gray-400 px-2 py-1 text-center"><span className='inline-block'>{student?.phoneNumber?.slice(5)}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Footer Section */}
                <div className="mt-8 flex justify-between">
                  <div className="text-sm text-gray-600">
                    <p>Total Students: {students?.length || 0}</p>
                    <p>Date: {new Date().toLocaleDateString()}</p>
                  </div>
                  <div className="text-sm text-gray-600">
                    <p>Signature: _________________</p>
                    <p>Teacher/Examiner</p>
                  </div>
                </div>
              </div>
          
          </div>
        </div>
      </div>
    );
  };
  
  export default ResultEmptyFileDownload;